module.exports = __webpack_public_path__ + "assets/img/return.8112258b.png";